<template>
  <div class="app-container">
    <el-card class="config-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="card-title">小区租车配置</span>
      </div>

      <el-form
        ref="ruleForm"
        :model="viewData"
        :rules="rules"
        label-width="120px"
        size="small"
      >
        <!-- 小区选择区域 -->
        <el-row :gutter="20" type="flex" align="middle" class="query-row">
          <el-col :span="8">
            <el-form-item label="选择小区" prop="commId">
              <el-select
                v-model="viewData.commId"
                clearable
                filterable
                placeholder="请选择小区"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionList"
                  :key="item.commId"
                  :label="item.commName"
                  :value="item.commId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="query-button-col">
            <el-button
              type="primary"
              style="background:#1890ff;border-color:#1890ff;margin-bottom:18px"
              @click="getConfig(viewData.commId)"
              :loading="loading"
            >
              查询配置
            </el-button>
          </el-col>
        </el-row>

        <!-- 基础信息卡片 -->
        <el-card class="info-card" shadow="hover">
          <div slot="header">
            <i class="el-icon-info"></i>
            <span>基础信息</span>
          </div>

          <el-row :gutter="20">
            <!-- 负责人信息 -->
            <el-col :span="6">
              <el-form-item label="负责人姓名" prop="fuze_name">
                <el-input
                  v-model="viewData.fuze_name"
                  placeholder="请输入负责人姓名"
                  clearable
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="负责人电话" prop="fuze_phone">
                <el-input
                  v-model="viewData.fuze_phone"
                  placeholder="请输入负责人电话"
                  clearable
                />
              </el-form-item>
            </el-col>

            <!-- 位置信息 -->
            <el-col :span="6">
              <el-form-item label="经度" prop="lng">
                <el-input
                  v-model="viewData.lng"
                  placeholder="请输入经度"
                  clearable
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="纬度" prop="lat">
                <el-input
                  v-model="viewData.lat"
                  placeholder="请输入纬度"
                  clearable
                />
              </el-form-item>
            </el-col>
            </el-row>
          <el-row :gutter="20">
            <!-- 租车配置 -->
            <el-col :span="6">
              <el-form-item label="免费租车时长" prop="mianfeizuche_day">
                <el-input
                  v-model="viewData.mianfeizuche_day"
                  placeholder="请输入天数"
                  clearable
                >
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="自然年多少次" prop="ziran_nian_cishu">
                <el-input
                  v-model="viewData.ziran_nian_cishu"
                  placeholder="请输入次数"
                  clearable
                >
                  <template slot="append">次</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="租车押金" prop="zuche_yajin">
                <el-input
                  v-model="viewData.zuche_yajin"
                  placeholder="请输入金额"
                  clearable
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="预约最小提前天" prop="yuyue_tiqian_day">
                <el-input
                  v-model="viewData.yuyue_tiqian_day"
                  placeholder="请输入天数"
                  clearable
                >
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item label="预约提前最大天" prop="yuyumax_day">
                <el-input
                  v-model="viewData.yuyumax_day"
                  placeholder="请输入天数"
                  clearable
                >
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
            </el-col>
            </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="逾期每天扣费" prop="yuqi_tian_jine">
                <el-input
                  v-model="viewData.yuqi_tian_jine"
                  placeholder="请输入金额"
                  clearable
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item label="退款时间" prop="huanche_tuikuan">
                <el-input
                  v-model="viewData.huanche_tuikuan"
                  placeholder="请输入天数"
                  clearable
                >
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="text-center">
              <el-form-item label="详细地址" prop="address">
              <el-input
                v-model="viewData.address"
                placeholder="请输入详细地址"
                clearable
                style="width: 100%;"
              />  
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 图片上传卡片 -->
        <el-card class="upload-card" shadow="hover">
          <div slot="header">
            <i class="el-icon-picture"></i>
            <span>图片配置</span>
          </div>

          <el-row :gutter="40">
            <el-col :xs="24" :md="12">
              <el-form-item label="预约协议合同">
                <div class="upload-tips">
                  <p>上传图片格式为'png'，大小不超过2M</p>
                  <p>请自行处理宽高比例</p>
                </div>
                <image-upload
                  ref="imageUpload"
                  v-if="showUpload"
                  :image-list="imageDefaultList"
                  :maxNumber="1"
                  @updateImg="onUpdateImg($event)"
                />
              </el-form-item>
            </el-col>

            <el-col :xs="24" :md="12">
              <el-form-item label="公章照片">
                <div class="upload-tips">
                  <p>上传图片格式为'png'，大小不超过2M</p>
                  <p>建议尺寸'450*450'，请自行处理宽高比例</p>
                </div>
                <image-upload
                  ref="imageUpload1"
                  v-if="showUpload1"
                  :image-list="imageDefaultList1"
                  :maxNumber="1"
                  @updateImg="onUpdateImg1($event)"
                />
              </el-form-item>
            </el-col>

            <el-col :xs="24" :md="12">
              <el-form-item label="位置截图" prop="map_thumb">
                <div class="upload-tips">
                  <p>上传图片格式为'png'，大小不超过2M</p>
                  <p>请自行处理宽高比例</p>
                </div>
                <image-upload
                  ref="imageUpload2"
                  v-if="showUpload2"
                  :image-list="imageDefaultList2"
                  :maxNumber="1"
                  @updateImg="onUpdateImg2($event)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 操作按钮 -->
        <el-row>
          <el-col :span="24" class="text-center">
            <el-button
              type="primary"
              size="medium"
              style="background:#1890ff;border-color:#1890ff; min-width: 120px"
              @click="submitForm"
              :loading="submitLoading"
            >
              保存配置
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import fetch from "../../../api/tianzheng/zucheinfo";
import ImageUpload from "@/components/Upload/image";
import Qu from "@/api/tianzheng/Qu";

export default {
  data() {
    return {
      loading: false,
      submitLoading: false,
      viewData: {
        commId: "",
        kaiqi_zhuangtai: "",
        xieyi_pic: "",
        gongzhang_pic: "",
        mianfeizuche_day: "",
        zuche_yajin: "",
        yuqi_tian_jine: "",
        yuyue_tiqian_day: "",
        yuyumax_day: "",
        ziran_nian_cishu: 3,
        huanche_tuikuan: "",
        lng: "",
        lat: "",
        fuze_name: "",
        fuze_phone: "",
        address: "",
        map_thumb: "",
      },
      showUpload: true,
      showUpload1: true,
      showUpload2: true,
      imageDefaultList: "",
      imageDefaultList1: "",
      imageDefaultList2: "",
      thumbList: [],
      thumbList1: [],
      thumbList2: [],
      optionList: [],
      rules: {
        commId: [
          { required: true, message: "请选择小区", trigger: "change" }
        ],
        fuze_name: [
          { required: true, message: "请输入负责人姓名", trigger: "blur" }
        ],
        fuze_phone: [
          { required: true, message: "请输入负责人电话", trigger: "blur" },
        ],
        lng: [
          { required: true, message: "请输入经度", trigger: "blur" },
          {
            pattern: /^-?((1[0-7]\d|\d{1,2})(\.\d+)?|180(\.0+)?)$/,
            message: "请输入正确的经度(-180~180)",
            trigger: "blur"
          }
        ],
        lat: [
          { required: true, message: "请输入纬度", trigger: "blur" },
          {
            pattern: /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
            message: "请输入正确的纬度(-90~90)",
            trigger: "blur"
          }
        ],
        mianfeizuche_day: [
          { required: true, message: "请输入免费租车时长", trigger: "blur" },
          {
            type: "number",
            transform: (value) => Number(value),
            min: 0,
            message: "天数必须大于等于0",
            trigger: "blur"
          }
        ],
        yuyue_tiqian_day: [
          { required: true, message: "请输入预约最小提前天数", trigger: "blur" },
          {
            type: "number",
            transform: (value) => Number(value),
            min: 0,
            message: "天数必须大于等于0",
            trigger: "blur"
          }
        ],
        yuyumax_day: [
          { required: true, message: "请输入预约提前最大天数", trigger: "blur" },
          {
            type: "number",
            transform: (value) => Number(value),
            min: 1,
            message: "天数必须大于0",
            trigger: "blur"
          }
        ],
        ziran_nian_cishu: [
          { required: true, message: "请输入自然年可预约次数", trigger: "blur" },
          {
            type: "number",
            transform: (value) => Number(value),
            min: 1,
            message: "次数必须大于0",
            trigger: "blur"
          }
        ],
        zuche_yajin: [
          { required: true, message: "请输入租车押金", trigger: "blur" },
          {
            type: "number",
            transform: (value) => Number(value),
            min: 0,
            message: "金额必须大于等于0",
            trigger: "blur"
          }
        ],
        yuqi_tian_jine: [
          { required: true, message: "请输入逾期扣费", trigger: "blur" },
          {
            type: "number",
            transform: (value) => Number(value),
            min: 0,
            message: "金额必须大于等于0",
            trigger: "blur"
          }
        ],
        huanche_tuikuan: [
          { required: true, message: "请输入退款时间", trigger: "blur" },
          {
            type: "number",
            transform: (value) => Number(value),
            min: 0,
            message: "天数必须大于等于0",
            trigger: "blur"
          }
        ],
      },
    };
  },
  components: {
    ImageUpload,
  },
  created() {
    this.getSelectCity();
  },
  methods: {
    onUpdateImg(val) {
      const thumbList = [];
      val.forEach((ele) => {
        thumbList.push(ele.path);
      });
      this.thumbList = thumbList;
    },
    onUpdateImg1(val) {
      const thumbList = [];
      val.forEach((ele) => {
        thumbList.push(ele.path);
      });
      this.thumbList1 = thumbList;
    },
    onUpdateImg2(val) {
      const thumbList = [];
      val.forEach((ele) => {
        thumbList.push(ele.path);
      });
      this.thumbList2 = thumbList;
    },
    getSelectCity() {
      Qu.select({}).then((res) => {
        if (res.code === 200) {
          this.optionList = res.result;
          this.viewData.commId = res.result[0].commId;
          this.getConfig(this.viewData.commId);
        }
      });
    },
    // 获取配置
    getConfig(commId) {
      if (!commId) {
        this.$message.warning("请先选择小区");
        return;
      }

      this.loading = true;
      const tempCommId = commId;
      this.initForm();
      this.viewData.commId = tempCommId;

      fetch.cominfodetail({ commId }).then((res) => {
        this.loading = false;
        if (res.code === 200) {
          if (res.result != null) {
            this.viewData = res.result;
            if (this.viewData.ziran_nian_cishu === undefined || this.viewData.ziran_nian_cishu === null || this.viewData.ziran_nian_cishu === '') {
              this.viewData.ziran_nian_cishu = 3;
            }

            if (this.viewData.xieyi_pic) {
              const ele = this.viewData.xieyi_pic;
              const imgList = [
                {
                  name: ele,
                  path: ele,
                  url: this.$publicData.imgUrl + ele,
                },
              ];
              this.imageDefaultList = JSON.stringify(imgList);
            }

            if (this.viewData.gongzhang_pic) {
              const ele = this.viewData.gongzhang_pic;
              const imgList = [
                {
                  name: ele,
                  path: ele,
                  url: this.$publicData.imgUrl + ele,
                },
              ];
              this.imageDefaultList1 = JSON.stringify(imgList);
            }

            if (this.viewData.map_thumb) {
              const ele = this.viewData.map_thumb;
              const imgList = [
                {
                  name: ele,
                  path: ele,
                  url: this.$publicData.imgUrl + ele,
                },
              ];
              this.imageDefaultList2 = JSON.stringify(imgList);
            }
          } else {
            this.viewData.commId = tempCommId;
          }
        } else {
          this.$message.error(res.message || "获取配置失败");
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error("网络错误，请重试");
      });
    },
    // 保存配置
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.viewData.xieyi_pic = this.thumbList.length === 0 ? "" : this.thumbList[0];
          this.viewData.gongzhang_pic = this.thumbList1.length === 0 ? "" : this.thumbList1[0];
          this.viewData.map_thumb = this.thumbList2.length === 0 ? "" : this.thumbList2[0];

          fetch.cominfoedit(this.viewData).then((res) => {
            this.submitLoading = false;
            if (res.code === 200) {
              this.$message.success("保存成功");
            } else {
              this.$message.error(res.message || "保存失败");
            }
          }).catch(() => {
            this.submitLoading = false;
            this.$message.error("网络错误，请重试");
          });
        } else {
          this.$message.warning("请填写完整的配置信息");
          return false;
        }
      });
    },
    initForm() {
      if (this.$refs.imageUpload) {
        this.$refs.imageUpload.clearFileList();
      }
      if (this.$refs.imageUpload1) {
        this.$refs.imageUpload1.clearFileList();
      }
      if (this.$refs.imageUpload2) {
        this.$refs.imageUpload2.clearFileList();
      }

      this.showUpload = true;
      this.showUpload1 = true;
      this.showUpload2 = true;
      this.imageDefaultList = "";
      this.imageDefaultList1 = "";
      this.imageDefaultList2 = "";
      this.thumbList = [];
      this.thumbList1 = [];
      this.thumbList2 = [];

      this.viewData = {
        commId: "",
        kaiqi_zhuangtai: "",
        xieyi_pic: "",
        gongzhang_pic: "",
        mianfeizuche_day: "",
        zuche_yajin: "",
        yuqi_tian_jine: "",
        yuyue_tiqian_day: "",
        yuyumax_day: "",
        ziran_nian_cishu: 3,
        huanche_tuikuan: "",
        lng: "",
        lat: "",
        fuze_name: "",
        fuze_phone: "",
        address: "",
        map_thumb: "",
      };
    },
  },
};
</script>

<style scoped>
.app-container {
  min-height: calc(100vh - 98px);
  padding: 20px;
  background-color: #f5f5f5;
}

.config-card {
  max-width: 1200px;
  margin: 0 auto;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.info-card,
.upload-card {
  margin-bottom: 20px;
}

.info-card .el-card__header,
.upload-card .el-card__header {
  background-color: #fafafa;
  border-bottom: 1px solid #ebeef5;
}

.info-card .el-card__header i,
.upload-card .el-card__header i {
  margin-right: 8px;
  color: #409eff;
}

.upload-tips {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 16px;
}

.upload-tips p {
  margin: 0 0 4px 0;
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
}

.upload-tips p:last-child {
  margin-bottom: 0;
}

.upload-card ::v-deep .el-upload__tip {
  display: none;
}

.text-center {
  text-align: center;
}

.query-button-col {
  display: flex;
  align-items: center;
  padding-top: 0;
}

.query-button-col .el-button {
  height: 32px; /* 调整为与输入框一致的高度 */
  line-height: 30px;
  padding: 0 15px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .app-container {
    padding: 10px;
  }

  .card-title {
    font-size: 16px;
  }

  .query-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .query-row .el-col {
    margin-bottom: 10px;
  }

  .query-button-col {
    padding-bottom: 0;
    justify-content: flex-start;
  }
}
</style>
